import { render, staticRenderFns } from "./LoanHistory.vue?vue&type=template&id=22a790fe&scoped=true&"
import script from "./LoanHistory.vue?vue&type=script&lang=js&"
export * from "./LoanHistory.vue?vue&type=script&lang=js&"
import style0 from "./LoanHistory.vue?vue&type=style&index=0&id=22a790fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a790fe",
  null
  
)

export default component.exports